import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import Autocomplete from '@material-ui/lab/Autocomplete';
import {Chip, TextField,MenuItem, Tooltip} from '@material-ui/core'
import {isUndefined,isEmpty} from 'lodash'
import {addNewAccountTag, removeTagFromSource} from 'actions'
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';

const tags = [
    {id: 1, Keyword: 'test'},
    {id: 1, Keyword: 'test1'},
    {id: 1, Keyword: 'test2'},
    {id: 1, Keyword: 'test3'},
]

function TaggarComponent(props) {
    const dispatch = useDispatch()

    const TagType = isUndefined(props.TagType) ? 0 : props.TagType
    let placeholder = props.intl.formatMessage({ id: 'Choose' });
    const AccountTags = useSelector(state => state.accountsData.AccountTags)
    const Afid = useSelector(state => state.accountsData.currentAccount.id)
    const Userid = useSelector(state => state.auth.authUser.user_id)
    const Role = useSelector(state => state.auth.authUser.user_role)

    const [taggar, setTaggar] = React.useState(isUndefined(props.tags) ? [] : props.tags)
    const [triggerRerender, setTriggerRerender] = React.useState(true)
    const [keyword, setKeyword] = React.useState("")

    const handleAddTag = (tag) => {
        setKeyword("")
        setTriggerRerender(state => !state)
        if(isUndefined(taggar.find(t => t.Keyword === tag.Keyword))){
            setTaggar(state => { 
                if(!isUndefined(props.Sourceid)) dispatch(addNewAccountTag(Afid, Userid, tag.Keyword, props.Source, props.Sourceid, TagType))
                if(!isUndefined(props.onChange)) props.onChange(state.concat([tag]) )
                return state.concat([tag]) 
            })
        }
    }
    const handleDelete = (tag) => {
        setTaggar(state => { 
            if(!isUndefined(props.Sourceid)) dispatch(removeTagFromSource(Afid, Userid, tag.Keyword, props.Source, props.Sourceid))
            if(!isUndefined(props.onChange)) props.onChange(state.filter(t => t.Keyword !== tag.Keyword) )

            return state.filter(t => t.Keyword !== tag.Keyword) 
        })
        
    }
    React.useEffect(()=>{
        if(!isUndefined(props.tags)){
            setTaggar(props.tags)
        }
    },[props.tags])
    const filterString = (str) => {
        // let regex = /[^A-Öa-ö0-9]+/
        return String(str).replace(/[^A-Öa-ö0-9]/g,'')
    }

    const returnKeyByValue = (Source) => {
        //18 GetAccept
      switch(Source) {
        case 1: return 'AntalTaggningarKund'
        case 2: return 'AntalTaggningarMote'
        case 3: return 'AntalTaggningarAvtal'
        case 4: return 'AntalTaggningarArende'
        case 5: return 'AntalTaggningarProjekt'
        case 6: return 'AntalTaggningarOrder'
        case 7: return 'AntalTaggningarAktiviteter'
        case 8: return 'AntalTaggningarEsignering'
        case 18: return 'AntalTaggningarEsignering'
        case 9: return 'AntalTaggningarKontakter'
        default: return 'AntalTaggningarKund'
      }
    }
    console.log(props,"JKKKAL")
    return (
        <div className='w-100'>
            <Autocomplete
                className="mb-2"
                key={triggerRerender}
                id="combo-box-demo"
                disabled={isUndefined(props.disabled)?false:props.disabled}
                options={AccountTags.filter(t => t.TagType === TagType).sort((a,b) => b[returnKeyByValue(props.Source)] - a[returnKeyByValue(props.Source)])}
                getOptionLabel={(option) => '#'+option.Keyword}
                fullWidth
                
                // value={keyword}
                onChange={(e,Value)=>handleAddTag(Value)}
                filterOptions={(options, filter) => {
                    if(filter.inputValue === "")
                        return options
                    else {
                        let results = options.filter(o => String(o.Keyword).toUpperCase().startsWith(String(filter.inputValue).toUpperCase()))

                        if(results.length === 0 && keyword !== '' && parseInt(Role) === 1) return [{id: 0, Keyword: keyword, TagType}]

                        return results
                    }
                }}
                renderOption={(tag,o) => { 
                    if(tag.id === 0)  {
                        return (
                            <React.Fragment>
                                <Tooltip title={<IntlMessages id="Tag.Add.new"/>} aria-label='Lägg till ny tagg!' placement='right'>
                                    <div className={"w-100 h-100 text-primary"}>{'#'+tag.Keyword}</div>
                                </Tooltip>
                            </React.Fragment>
                        )
                    }
                    if(parseInt(tag[returnKeyByValue(props.Source)]) === 0) {
                      return (
                        <div className={"w-100 h-100 text-grey"}>{'#'+tag.Keyword}</div>
                      )
                    }
                    return '#'+tag.Keyword
                }}
                renderInput={(params) => 
                <TextField 
                    {...params} 
                    fullWidth
                    label={<IntlMessages id="Tags.label"/>}
                    variant="outlined"
                    size="small"
                    placeholder={placeholder}
                    disabled={isUndefined(props.disabled)?false:props.disabled}
                    onChange={(e) => setKeyword(filterString(e.target.value))}
                    // onBlur={(e)=>this.selectedThisValue(e.target.value)}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            }
            />
            {
                !isEmpty(taggar) && taggar.map(t => {
                    console.log(t,"JKKKAL")
                    if(parseInt(props.Source) === 3){
                        if(parseInt(t.Source) === 3){
                            return <Chip 
                                className="mr-1 mb-1"
                                disabled={isUndefined(props.disabled)?false:props.disabled}
                                label={'#'+t.Keyword} onDelete={() => handleDelete(t)} size="small"
                            />
                        }
                        else{
                            return <Chip 
                                className="mr-1 mb-1"
                                disabled={isUndefined(props.disabled)?false:props.disabled}
                                label={'#'+t.Keyword} 
                                //onDelete={() => handleDelete(t)} 
                                size="small"
                            />
                        }
                    }else{
                        return (
                            <Chip 
                                className="mr-1 mb-1"
                                disabled={isUndefined(props.disabled)?false:props.disabled}
                                label={'#'+t.Keyword} 
                                onDelete={() => handleDelete(t)} 
                                size="small"
                            />
                        )
                    }
                    
                })
            }
        </div>
    )
}
export default injectIntl(TaggarComponent);
